import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import PageNotFound from "../views/PageNotFound";
Vue.use(VueRouter);





const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return true;
  }
  next('/');

  return false;
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return true;
  }
  next('/login');

  return false;
};

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v2',
    name: 'home-v2',
    component: Home,
    beforeEnter: ifAuthenticated,
    meta: { salesStatsVersion: 'v2' },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    beforeEnter: ifAuthenticated,

  },
  {
    path: "/dashboard/:type",
    name: "dashboard",
    component: () => import('../views/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      if(!ifAuthenticated(to, from, url => String(url).length > 0 ? next(url) : null)){

        return;
      }
      store.commit('boards/setActiveBoard', to.params.type, {root: true});
      next();
     },

  },
  {
    path: "*",
    name: "404",
    component: PageNotFound,
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
